export const ZoneMessage = {
    'add': 'Zone succesvol toegevoegd',
    'edit': 'Zone succesvol bijgewerkt',
    'delete': 'Zone succesvol verwijderd'
}
export const ErrorMessage = {
    'error':'Fout tijdens toevoegen ',
    'errorMove':'Fout tijdens verplaatsen ',
    'errorReport':'Fout tijdens melden doorbraak '
}
export const FirePartitionMessage = {
    'add': 'Brandpartitie succesvol toegevoegd',
    'edit': 'Brandpartitie succesvol bijgewerkt',
    'delete': 'Brandpartitie succesvol verwijderd',
    'move': 'Brandpartitie succesvol verplaatst',
    'report': 'Doorbraak succesvol gemeld',
    'conflict': 'Doorbraak reeds gemeld'
}
export const LinkFirePartitionMessage = {
    'add': 'Succesvol gekoppeld',
    'delink': "Succesvol ontkoppeld"
}
